import { ReactComponent as EditSvg } from '../../assets/icons/edit.svg';

export const EditIcon: SvgIcon = (props) => {
    return <EditSvg {...props} />;
};
